import { render, staticRenderFns } from "./BashCommands.vue?vue&type=template&id=3f910e5d&scoped=true&"
import script from "./BashCommands.vue?vue&type=script&lang=js&"
export * from "./BashCommands.vue?vue&type=script&lang=js&"
import style0 from "./BashCommands.vue?vue&type=style&index=0&id=3f910e5d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f910e5d",
  null
  
)

export default component.exports